import React from "react";

import { faXmark } from "@fortawesome/pro-light-svg-icons";
import { faArrowLeft } from "@fortawesome/pro-solid-svg-icons";
import { twJoin } from "tailwind-merge";

import { IconButton } from "src/design-system/Icon";
import { rightSidePaneWidthClassname } from "src/flowContainer/RightPane";

type SubPaneLayoutProps = {
  children: React.ReactNode;
  onBackButtonClick: () => void;
  onCloseButtonClick: () => void;
  title: string;
};

export const SubPaneLayout: React.FC<SubPaneLayoutProps> = ({
  children,
  onBackButtonClick,
  onCloseButtonClick,
  title,
}) => {
  return (
    <div className={twJoin("bg-white px-4 pt-4", rightSidePaneWidthClassname)}>
      <div className="mb-4 flex flex-row items-center justify-between text-gray-800">
        <div className="flex">
          <IconButton
            icon={faArrowLeft}
            size="xs"
            onClick={onBackButtonClick}
          />
          <div className="ml-2 font-inter-semibold-16px">{title}</div>
        </div>
        <IconButton icon={faXmark} size="xs" onClick={onCloseButtonClick} />
      </div>
      {children}
    </div>
  );
};
